import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'
import { SourceName } from '../../'

interface SourceNameApi {
  cidr_blocks: string[]
  expiration: number
  expired: boolean
  id: number
  last_modified: number
  name: string
  start: number
}
interface SourceNameApiResponse extends BaseApiResponse {
  source_names: SourceNameApi[]
}

export async function getSourceNames(
  this: ThisConnector,
  { organizationUuid }: { organizationUuid: string }
): Promise<SourceName[]> {
  const { source_names: sourceNames } =
    await this.connector.get<SourceNameApiResponse>(
      `/${organizationUuid}/protect/sourcename`
    )
  return sourceNames.map(normalizeSourceName)
}

function normalizeSourceName({
  cidr_blocks,
  expiration,
  expired,
  id,
  last_modified,
  name,
  start
}: SourceNameApi) {
  return {
    cidrBlocks: cidr_blocks,
    expiration: expiration ? new Date(expiration).toISOString() : undefined,
    expired,
    id: `${id}`,
    modified: new Date(last_modified).toISOString(),
    name,
    start: new Date(start).toISOString()
  }
}
